declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

// Booking is on Microsoft Bookings (2026-08) — two 30-min meeting types, split so
// the product-demo and WebCenter-consulting pipelines stay separately traceable.
// Constant names kept (they no longer refer to Calendly) to avoid churning call-sites.
const CALENDLY_DEMO_URL =
  'https://outlook.office.com/bookwithme/user/ca2e84f5d95b4280a34073c39ee722f3@ezcloud.ai/meetingtype/cGjhRG1JmkSrBrj2cFWWjA2?anonymous&ismsaljsauthenabled&ep=mlink';
const CALENDLY_WEBCENTER_URL =
  'https://outlook.office.com/bookwithme/user/ca2e84f5d95b4280a34073c39ee722f3@ezcloud.ai/meetingtype/5rqddBZ2D0-BcX8FjGlSMw2?anonymous&ismsaljsauthenabled&ep=mlink';

function trackEvent(name: string, params: Record<string, unknown> = {}): void {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, {
    page_path: typeof window !== 'undefined' ? window.location.pathname : undefined,
    ...params,
  });
}

export function trackFormSubmit(
  formName: string,
  extras: Record<string, unknown> = {},
): void {
  trackEvent('form_submit', { form_name: formName, ...extras });
}

export function trackCalendlyClick(source?: string): void {
  trackEvent('calendly_click', { source });
}

export function trackWebCenterDecisionCallClick(source?: string): void {
  trackEvent('webcenter_decision_call_click', { source });
}

export function trackChatOpen(source?: string): void {
  trackEvent('chat_open', { source });
}

export function openCalendlyDemo(source?: string): void {
  trackCalendlyClick(source);
  if (typeof window !== 'undefined') {
    window.open(CALENDLY_DEMO_URL, '_blank');
  }
}

export function openWebCenterDecisionCall(source?: string): void {
  trackWebCenterDecisionCallClick(source);
  if (typeof window !== 'undefined') {
    window.open(CALENDLY_WEBCENTER_URL, '_blank');
  }
}

export { CALENDLY_DEMO_URL, CALENDLY_WEBCENTER_URL };
